import useDiscloserHook from '../app/features/settings/discloser/discloser.hook';
import useFiltersHook from '../app/features/settings/filters/filters.hook';

export const useAppFilters = useFiltersHook;
export const useAppDiscloser = useDiscloserHook;

export default { useAppDiscloser, useAppFilters };
